import { getSelectBoxOptionsFromConstants } from "../utils/commonUtils"
import SkillLevel from "./SkillLevel"

export const SkillLevelOptions = getSelectBoxOptionsFromConstants(SkillLevel)